import { Decorable } from './../../../types/decorable';
import { ICancellablePromise } from './../../../types/cancellable-promise';
import { ServerService } from 'app/model/services/api-services/server.service';
import { Injectable } from '@angular/core';
import { ProjectMetadata } from 'app/types/project-config';

export type ProjectItemMetadata = {
  project_id: number;
  name: string;

}
export type FilterUnixDate = number;
export type FilterDateType = 'created' | 'modified';
export type FitlerDateComparison = '=' | 'gt' | 'gte' | 'lt' | 'lte';
export type FilterDate = {
  type: FilterDateType;
  comparison: FitlerDateComparison;
  value: FilterUnixDate;
}
export type ProjectListFilters = {
  stage?: string | number;
  workflow?: string;
  fromDate?: FilterDate;
  toDate?: FilterDate;
}

export type ProjectFilterTypes = 'none' | 'workflow' | 'stage' | 'name';

export type ProjectFilter = {
  type: ProjectFilterTypes;
  value?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ProjectsService {
  private projects: Array<ProjectMetadata> = [];
  constructor(private server: ServerService) { }

  ListProjects(filterBy?: ProjectListFilters): ICancellablePromise {
    const params: Decorable = (!!filterBy) ? {
      filterBy: filterBy
    } : {};
    return this.server.Post('project/list', params);
  }
  GetProject(projectId:string|number) {
    const params:Decorable = {
      'project_id':projectId,
      'by':'project_id'
    }
    return this.server.Post('project/config/load',params);
  }
}
